
export class RowGroup {
    constructor(
        public Items: Array<any>,
        public IsVisible: boolean,
        public Height: Number) { }
    
}



// WEBPACK FOOTER //
// C:/Users/jjarvis/projects/pm-controls/source/app/objects/request/row-group.ts